import { get } from 'lodash';
import { EMPTY_OBJECT } from '../../constants/utils';

export const getUserContext = state => get(state, 'userContext', EMPTY_OBJECT);
export const getTvaIntra = state => get(state, 'userContext.tvaIntra', '');
export const getPromotionNotify = state => get(state, 'userContext.promotionNotify', EMPTY_OBJECT);
